<kt-portlet class="knostos-grid">
  <kt-portlet-header
    [title]="title + ' List'"
    [class]="'card-head-lg'"
    [viewLoading$]="dataSource.loading$"
  >
    <ng-container ktPortletTools>
      <div>
        <ng-template ngxPermissionsOnly="canAddTeam">
          <button mat-raised-button class="btn btn-primary" (click)="createCategory()">
            <span
              inlineSVG="assets/media/svg/icons/General/add_circle_icon.svg"
              class="svg-icon svg-icon-md"
            ></span>
            <span>Add {{ title }}</span>
          </button>
        </ng-template>
        <button
          mat-raised-button
          matTooltip="Export as CSV"
          class="btn btn-icon btn-primary ml-2"
          (click)="exportCategoriesAsCSV($event)"
        >
          <i class="fas fa-download"></i>
        </button>
      </div>
    </ng-container>
  </kt-portlet-header>
  <kt-portlet-body>
    <div class="d-flex align-items-end justify-content-end mb-5">
      <mat-form-field appearance="standard">
        <mat-label>{{ 'TABLE.SEARCH' | translate }}</mat-label>
        <input matInput #searchInput [placeholder]="'TABLE.SEARCH' | translate" />
        <button
          *ngIf="searchInput.value"
          matSuffix
          mat-icon-button
          aria-label="Clear"
          (click)="resetInput($event, searchInput, true)"
        >
          <mat-icon>close</mat-icon>
        </button>
        <mat-hint align="start">
          <strong>{{ 'TABLE.SEARCH' | translate }}</strong>
          {{ 'TABLE.IN_ALL_FIELDS' | translate }}
        </mat-hint>
      </mat-form-field>
      <button
        matTooltip="Search by Field/s"
        style="margin-bottom: 1.34375em"
        class="btn btn-sm btn-icon btn-light ml-2"
        (click)="toggleSearchBar($event)"
      >
        <span
          inlineSVG="assets/media/svg/icons/General/columns.svg"
          class="svg-icon svg-icon-md"
        ></span>
      </button>
    </div>
    <div class="mat-table-wrapper">
      <mat-table #sort="matSort" matSort [dataSource]="dataSource" class="mat-elevation-z8">
        <ng-container matColumnDef="id">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'CATEGORY.TABLE.ID' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let category">{{ category.id }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchId">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'CATEGORY.TABLE.ID' | translate }}</mat-label>
              <input
                matInput
                #searchIdInput
                type="number"
                min="1"
                [placeholder]="'CATEGORY.TABLE.ID' | translate"
              />
              <button
                *ngIf="searchIdInput.value"
                matSuffix
                mat-icon-button
                aria-label="Clear"
                (click)="resetInput($event, searchIdInput)"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="mangers">
          <mat-header-cell class="mat-column-id" *matHeaderCellDef>Team Managers</mat-header-cell>
          <mat-cell class="mat-column-id d-flex flex-center" *matCellDef="let category">
            <div style="width: 60px !important" class="symbol-group symbol-hover">
              <div
                *ngIf="category?.managers?.length && usersObj?.length"
                [matTooltip]="getFullNameList(category?.managers[0])"
                matTooltipPosition="above"
              >
                <kt-user-photo
                  [size]="25"
                  [type]="'object'"
                  [editable]="false"
                  [user$]="getUser(category.managers[0])"
                ></kt-user-photo>
              </div>
              <div
                *ngIf="category?.managers?.length && usersObj?.length"
                class="symbol symbol-25 symbol-circle symbol-light-primary"
              >
                <span
                  [matTooltip]="getNameList(category.managers)"
                  matTooltipPosition="above"
                  class="symbol-label font-weight-bold"
                  >{{ category?.managers?.length - 1 }}+</span
                >
              </div>
            </div>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'CATEGORY.TABLE.NAME' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let category">{{ category.name }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchName">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'CATEGORY.TABLE.NAME' | translate }}</mat-label>
              <input matInput #searchNameInput [placeholder]="'CATEGORY.TABLE.NAME' | translate" />
              <button
                *ngIf="searchNameInput.value"
                matSuffix
                mat-icon-button
                aria-label="Clear"
                (click)="resetInput($event, searchNameInput)"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="role">
          <mat-header-cell *matHeaderCellDef>Role</mat-header-cell>
          <mat-cell *matCellDef="let category" class="d-block">
            <span *ngFor="let role of category.roles; let i = index" class="mr-1">
              {{ role.name + (i < category.roles.length - 1 ? ',' : '') }}
            </span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchRole">
          <mat-header-cell *matHeaderCellDef>
            <kt-general-autocomplete
              #searchRoleAutocomplete
              [label]="'Role'"
              [appearance]="'standard'"
              [dataPath]="'data'"
              [loadItemsFunction]="getRoleAutocomplete"
              [optionFormatter]="formatRoleOption"
              [valueFormatter]="formatRoleOption"
              [control]="searchRoleAutocomplete"
              [required]="false"
              [readOnly]="false"
            ></kt-general-autocomplete>
          </mat-header-cell>
        </ng-container>

        <ng-container matColumnDef="inbox">
          <mat-header-cell *matHeaderCellDef>Inbox</mat-header-cell>
          <mat-cell *matCellDef="let category">{{ category.inbox?.name }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchInbox">
          <mat-header-cell *matHeaderCellDef>
            <kt-general-autocomplete
              #searchInboxAutocomplete
              [label]="'Inbox'"
              [appearance]="'standard'"
              [dataPath]="'data'"
              [loadItemsFunction]="getInboxAutocomplete"
              [optionFormatter]="formatRoleOption"
              [valueFormatter]="formatRoleOption"
              [control]="searchInboxAutocomplete"
              [required]="false"
              [readOnly]="false"
            ></kt-general-autocomplete>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="isActive">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'USER.STATUS' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let category">
            <span
              style="width: 61px"
              class="label label-lg label-light-{{
                getItemCssClassByStatus(category.is_active)
              }} label-inline text-center"
            >
              {{ getItemStatusString(category.is_active) }}
            </span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchIsActive">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'TABLE.STATUS' | translate }}</mat-label>
              <mat-select
                [(value)]="searchIsActiveSelect"
                [placeholder]="'TABLE.STATUS' | translate"
              >
                <mat-option value="">All</mat-option>
                <mat-option value="true">Active</mat-option>
                <mat-option value="false">Inactive</mat-option>
              </mat-select>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef>{{ 'TABLE.ACTIONS' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let category">
            <ng-template ngxPermissionsOnly="canEditTeam">
              <button
                matTooltip="{{ 'TABLE.UPDATE' | translate }} {{ title }}"
                class="btn btn-icon btn-light btn-hover-primary btn-sm m-1"
                (click)="editCategory(category)"
              >
                <span
                  inlineSVG="assets/media/svg/icons/General/edit_icon.svg"
                  class="svg-icon svg-icon-md svg-icon-primary"
                ></span>
              </button>
            </ng-template>
            <ng-template ngxPermissionsOnly="canSoftDeleteTeam">
              <button
                matTooltip="Activate/Deactivate Category"
                class="btn btn-icon btn-light btn-hover-warning btn-sm m-1"
                (click)="updateCategoryStatus(category)"
              >
                <span
                  inlineSVG="assets/media/svg/icons/General/update_icon2.svg"
                  class="svg-icon svg-icon-md svg-icon-warning"
                ></span>
              </button>
            </ng-template>
            <button
              matTooltip="{{ title }} Members"
              class="btn btn-icon btn-light btn-hover-secondary btn-sm m-1"
              (click)="teamMembers(category)"
            >
              <span
                inlineSVG="assets/media/svg/icons/Communication/Group.svg"
                class="svg-icon svg-icon-md svg-icon-secondary"
              ></span>
            </button>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchActions">
          <mat-header-cell *matHeaderCellDef>
            <button
              class="btn btn-sm btn-light-primary w-50 m-1"
              (click)="handleSearchByField($event)"
            >
              {{ 'TABLE.SEARCH' | translate }}
            </button>
            <button class="btn btn-sm btn-light w-50 m-1" (click)="resetSearchBar($event)">
              {{ 'GLOBAL.RESET' | translate }}
            </button>
          </mat-header-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns" class="sticky-header"></mat-header-row>
        <mat-header-row
          [hidden]="!showSearchBar"
          *matHeaderRowDef="searchBarColumns"
          class="search-cols sticky-header"
        ></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>
      <div class="mat-table-message" *ngIf="!dataSource.hasItems">
        {{ 'GLOBAL.NO_RECORDS_FOUND' | translate }}
      </div>
      <div class="mat-table-message" *ngIf="dataSource.isPreloadTextViewed$ | async">
        {{ 'GLOBAL.PLEASE_WAIT' | translate }}
      </div>
    </div>
  </kt-portlet-body>
  <kt-portlet-footer>
    <div class="mat-table__bottom">
      <mat-paginator
        [pageSize]="10"
        [pageSizeOptions]="[10, 25, 50, 200]"
        [length]="dataSource.paginatorTotal$ | async"
        [showFirstLastButtons]="true"
      ></mat-paginator>
    </div>
  </kt-portlet-footer>
</kt-portlet>
